import { Component, Input, OnInit, Pipe } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {
  @Input() backgroundImage: string;
  @Input() vimeoId: string;
  @Input() padding = null;

  constructor(private sanitize: DomSanitizer) { }

  ngOnInit() {
  }

  safeStyle(style: string): SafeStyle {
    return this.sanitize.bypassSecurityTrustStyle(style);
  }

}
